export const MAX_FILE_SIZE_NORMAL_UPLOAD = 2000000;
export const MAX_FILE_SIZE_CONFIGURATION_UPLOAD = 1000000;
export const MAX_FILE_SIZE_MULTI_PAGES_UPLOAD = 10000000;
